
// // import React from "react";
// // import {  Route, Routes } from 'react-router-dom';
// // import Login from './components/Login'; // Assuming Login component is in the same directory
// // import App from './components/App'; // Your App page component

// // const Source = () => {
// //   return (
  
// //       <Routes>
// //         {/* Define your routes here */}
// //         <Route path="/" element={<Login />} />
// //         <Route path="/App" element={<App />} /> {/* Define the /App route */}
// //         {/* You can define other routes here as well */}
// //       </Routes>
  
// //   );
// // };

// // export default Source;
// import React from "react";
// import { Route, Routes, Navigate } from "react-router-dom";
// //import { Route, Routes } from "react-router-dom";
// import Login from './components/Login';
// import Audiopage from './components/Audiopage';

// const Source = () => {
//   const token = localStorage.getItem("token");

//   return (
//     <Routes>
//       {/* <Route path="/" element={token ? <Navigate to="/App" /> : <Login />} /> */}
//       <Route path="/" element={<Login />} />
//       {/* <Route path="/App" element={<App />} /> */}
//         <Route path="/App" element={token ? <Audiopage /> : <Navigate to="/" />} /> 
//        {/* <Route path="/App" element={localStorage.getItem('token') ? <App /> : <Navigate to="/" />} /> */}

//     </Routes>
//   );
// };

// export default Source;



//new code
// import { BrowserRouter as Router, Routes, Route, HashRouter } from "react-router-dom";
// import Login from "./components/Login";
// import Audiopage from "./components/Audiopage";
// import ProtectedRoute from "./components/ProtectedRoute.js"; // Import the protected route

// function App() {
//   return (

//       <Routes>
//         <Route path="/" element={<Login />} />
//         <Route 
//           path="/Audio" 
//           element={
//             <ProtectedRoute>
//               <Audiopage />
//             </ProtectedRoute>
//           } 
//         />
//       </Routes>

//   );
// }

// export default App;


//ujjwal changes
// import { HashRouter, Routes, Route } from "react-router-dom";
// import Login from "./components/Login";
// import Audiopage from "./components/Audiopage";
// import AdminPage from "./components/AdminPage";
// import ProtectedRoute from "./components/ProtectedRoute.js";

// function App() {
//   return (
//     <HashRouter>
//       <Routes>
//         <Route path="/" element={<Login />} />
//         <Route 
//           path="/audio" 
//           element={
//             <ProtectedRoute>
//               <Audiopage />
//             </ProtectedRoute>
//           } 
//         />
//         <Route 
//           path="/admin" 
//           element={
//             <ProtectedRoute>
//               <AdminPage />
//             </ProtectedRoute>
//           } 
//         />
//       </Routes>
//     </HashRouter>
//   );
// }

// export default App;

// App.js
// import { HashRouter, Routes, Route } from "react-router-dom";
// import Login from "./components/Login";
// import Audiopage from "./components/Audiopage";
// import AdminPage from "./components/AdminPage";
// import AudioList from "./components/AudioList"; 
// import ProtectedRoute from "./components/ProtectedRoute.js";

// function App() {
//   return (
//     <HashRouter>
//       <Routes>
//         <Route path="/" element={<Login />} />
//         <Route
//           path="/audio"
//           element={
//             <ProtectedRoute>
//               <Audiopage />
//             </ProtectedRoute>
//           }
//         />
//         <Route
//           path="/admin"
//           element={
//             <ProtectedRoute>
//               <AdminPage />
//             </ProtectedRoute>
//           }
//         />
//         <Route
//           path="/audio-list"
//           element={
//             <ProtectedRoute>
//               <AudioList />
//             </ProtectedRoute>
//           }
//         />
//       </Routes>
//     </HashRouter>
//   );
// }

// export default App;


//language
import { HashRouter, Routes, Route } from "react-router-dom";
import Login from "./components/Login";
import Audiopage from "./components/Audiopage";
import AdminPage from "./components/AdminPage";
import AudioList from "./components/AudioList";
import ProtectedRoute from "./components/ProtectedRoute.js";
import { LanguageProvider } from "./language/LanguageContext.js";
import "./axiosSetup"; // Global axios interceptor for auto-logout on expired token

function App() {
  return (
    <LanguageProvider>
      <HashRouter>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route
            path="/audio"
            element={
              <ProtectedRoute>
                <Audiopage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <AdminPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/audio-list"
            element={
              <ProtectedRoute>
                <AudioList />
              </ProtectedRoute>
            }
          />
        </Routes>
      </HashRouter>
    </LanguageProvider>
  );
}

export default App;